export enum CommunityArticleCoverType {
    PHOTOGRAPH_BRANDED = "PHOTOGRAPH_BRANDED",
    PHOTOGRAPH = "PHOTOGRAPH",
    ILLUSTRATION_BRANDED = "ILLUSTRATION_BRANDED",
    ILLUSTRATION = "ILLUSTRATION",
    WEBSITE = "WEBSITE",
    DEPENDENCY = "DEPENDENCY",
    PRODUCT_PLACEMENT = "PRODUCT_PLACEMENT",
    NONE = "NONE"
}
